import { useI18n } from "@wojo/localization";
import { Modal, ModalBody, type ModalProps, Text } from "@wojo/ui";
import React, { useId } from "react";

export type OldTripsModalProps = Omit<ModalProps, "accessibleTitle"> & {};

export const OldTripsModal: React.FC<OldTripsModalProps> = (props) => {
    const { heading, description } =
        useI18n("account").account.myTours.oldTripsModal;
    const accessibleTitleId = useId();
    return (
        <Modal {...props} accessibleTitleId={accessibleTitleId}>
            <ModalBody>
                <Text.Heading
                    order="3"
                    tag="h1"
                    style={{ paddingBottom: "var(--g-spacing-sm)" }}
                    id={accessibleTitleId}
                >
                    {heading.l()}
                </Text.Heading>
                <Text.Body>{description.l()}</Text.Body>
            </ModalBody>
        </Modal>
    );
};
